// extracted by mini-css-extract-plugin
export default {"root":"styles_root__6uGNf","leftPanel":"styles_leftPanel__xvUOn","container":"styles_container__mcMCR"};